import React from 'react';
import {clearState, setLoginState} from "../store/actions";
import {useDispatch} from "react-redux";
import {useNavigate } from 'react-router-dom';

const HeaderTitle = props => {


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const jumpTo = page => {
    navigate(page);
    return;
  };
  
        return (
          <header className="l-header">
              <div className="l-header__in">
                  <ul className="p-head">
                      <li className="p-head-c">ウロノート</li>

                    <li className="p-head-r"><a onClick={() => {
                      dispatch(setLoginState(false));
                      dispatch(clearState());
                      jumpTo("/login");
                    }}><i className="icon icon-logout"></i></a></li>
                    
                  </ul>
              </div>
          </header>)
}

export default HeaderTitle;
